import { Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { OtherInformation } from "./OtherInformation";
import { FlightInformation } from "./FlightInformation";
import { BusinessSource } from "./BusinessSource";

export const ReservationInformation: React.FC<any> = React.memo((props) => {
  const methods = useForm();
  const { handleSubmit, control, register } = methods;
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    navigate(path);
  };

  const tabs = [
    { label: "Other Information", content: <OtherInformation/> },
    { label: "Flight Information", content: <FlightInformation/> },
    { label: "Business Source", content: <BusinessSource/> },
  ];
  const onSubmit = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  return (
    <Grid
      container
      sx={{
    
        display: "flex",
        flexDirection: "column",
       
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Header section */}
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" color={"green"} padding={"1rem"}>
              Reservation Information
            </Typography>
            <IconButton onClick={() => handleClick("/waitinglist")}>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
              />
            </IconButton>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 2,p:"1rem" }} >
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography>Reservation No</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("reservationno")}
                    id="reservationno"
                    name="reservationno"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>First Name</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={""}
                    {...register("firstname")}
                    id="firstname"
                    name="firstname"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      padding: "0.3rem",
                      marginRight: "8px",
                      borderRadius: "2px",
                    }}
                  >
                    <WSIcons.SearchIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Last Name</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={""}
                    {...register("lastname")}
                    id="lastname"
                    name="lastname"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography># Adult</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={""}
                    {...register("adult")}
                    id="adult"
                    name="adult"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography># Child</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={""}
                    {...register("child")}
                    id="child"
                    name="child"
                    control={control}
                    rules={{ required: false }}
                  />

                  <Button
                    sx={{
                      mt: 4,
                      color: "black",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      borderColor: "gray",
                    }}
                    variant="outlined"
                  >
                    <WSIcons.FastfoodIcon
                      sx={{
                        backgroundColor: "green",
                        color: "white",
                        fontSize: "32px",
                        mr: 1,
                      }}
                      onClick={()=>handleClick('/orderitem')}
                    />
                    Order item
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
            <Grid
            sx={{
              border: '1px solid #ccc', 
            height:"30rem"
                             
            }}
          >
            <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />
          </Grid>
            </Grid>
            
          </Grid>
          <Grid
        item
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2} alignItems="center" gap={3}>
          <Grid item>
            <WSIcons.GTranslateIcon sx={{ color: "white" }} />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
        >
          SAVE
        </Button>
      </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
});
